// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"22392113","675":"d03613ef"}[chunkId] + ".chunk.js";
};